import styled from "styled-components";
import { apolloSpaceInlineHalfX, apolloFontSizeHeading2, apolloSpaceInsetHalfX, apolloSpaceInset4X, } from "@nexthink/apollo-tokens";
import Flex from "../box/Flex";
import Text from "../text/Text";
import { getDropDownStyles } from "../dropdown/Dropdown.style";
import { heightSmall } from "../menu/MenuItem.style";
const borderWidth = 1;
const focusedBorderWidth = 2;
const inputHeight = 24;
export const StyledRowRenderer = styled(Text).withConfig({ displayName: "StyledRowRenderer_APC-7311-productShell", componentId: "sc-1mvh30d" })(({ theme }) => ({
    color: theme.colors.apolloColorTextSecondary,
    height: heightSmall,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
}));
export const StyledSpinnerWrapper = styled(Flex).withConfig({ displayName: "StyledSpinnerWrapper_APC-7311-productShell", componentId: "sc-wwjrxw" })({
    height: `${heightSmall}px`,
    lineHeight: `${heightSmall}px`,
});
export const StyledErrorIconContainer = styled.span.withConfig({ displayName: "StyledErrorIconContainer_APC-7311-productShell", componentId: "sc-ulkhrc" })({
    marginLeft: apolloSpaceInlineHalfX,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    left: "auto",
    right: "10px",
    height: "16px",
    width: "16px",
});
export const StyledTagEditor = styled.div.withConfig({ displayName: "StyledTagEditor_APC-7311-productShell", componentId: "sc-nut9gw" })(({ theme, error, isInputFocused, disabled }) => (Object.assign(Object.assign(Object.assign(Object.assign({ width: "100%", background: theme.colors.apolloColorBackgroundFormElementDefault, borderRadius: apolloSpaceInlineHalfX, border: `1px solid ${theme.colors.apolloColorStrokeFormElementDefault}`, minHeight: apolloFontSizeHeading2, padding: `calc(${apolloSpaceInsetHalfX} - ${borderWidth}px)`, boxSizing: "border-box", color: theme.colors.apolloColorTextSecondary }, theme.textStyles.body), (error && {
    borderColor: theme.colors.apolloColorStrokeError,
    paddingRight: apolloSpaceInset4X,
})), (isInputFocused && {
    borderWidth: focusedBorderWidth,
    borderColor: theme.colors.apolloColorStrokeFocus,
    boxShadow: theme.colors.apolloBoxShadowFormElementFocusHighlight,
    padding: `calc(${apolloSpaceInsetHalfX} - ${focusedBorderWidth}px)`,
})), (disabled && {
    background: theme.colors.apolloColorBackgroundFormElementDisabled,
    borderColor: theme.colors.apolloColorStrokeFormElementDisabled,
}))));
export const StyledTagListContainer = styled(Flex).withConfig({ displayName: "StyledTagListContainer_APC-7311-productShell", componentId: "sc-1tp7q45" })({
    flexWrap: "wrap",
    margin: 0,
    padding: 0,
    outline: 0,
    gap: apolloSpaceInsetHalfX,
    textDecoration: "none",
    listStyle: "none",
});
export const StyledTagList = styled.ul.withConfig({ displayName: "StyledTagList_APC-7311-productShell", componentId: "sc-10j7l53" })({
    display: "contents",
});
export const StyledTagItem = styled.li.withConfig({ displayName: "StyledTagItem_APC-7311-productShell", componentId: "sc-19oibko" })({
    display: "inline-flex",
    overflow: "hidden",
    "&:nth-last-child(1)": {
        marginRight: apolloSpaceInlineHalfX,
    },
});
export const StyledInputRuler = styled.span.withConfig({ displayName: "StyledInputRuler_APC-7311-productShell", componentId: "sc-11xj1bk" })(({ theme, isPlaceholder }) => (Object.assign({ position: "absolute", visibility: "hidden", overflow: "hidden" }, (isPlaceholder ? theme.textStyles.bodyEmphasis : theme.textStyles.body))));
export const StyledInput = styled.input.withConfig({ displayName: "StyledInput_APC-7311-productShell", componentId: "sc-16ewsvt" })(({ theme, hasReachedLimit, width, disabled }) => (Object.assign(Object.assign(Object.assign({ flexGrow: 1, border: "none", height: inputHeight, color: theme.colors.apolloColorTextSecondary }, theme.textStyles.body), { display: hasReachedLimit ? "none" : "block", padding: 0, marginLeft: apolloSpaceInlineHalfX, background: "none", overflow: "hidden", textOverflow: "ellipsis", width, "&&:focus": {
        outline: 0,
        boxShadow: "none",
        border: 0,
    }, "&::placeholder": Object.assign({ color: disabled ? theme.colors.apolloColorTextDisabled : theme.colors.apolloColorTextSecondary }, theme.textStyles.bodyEmphasis) }), (disabled && {
    color: theme.colors.apolloColorTextDisabled,
}))));
export const StyledSuggestionsDropdown = styled.div.withConfig({ displayName: "StyledSuggestionsDropdown_APC-7311-productShell", componentId: "sc-1cv02ap" })(({ theme }) => (Object.assign(Object.assign({}, getDropDownStyles(theme, true)), { height: undefined, width: undefined, background: theme.colors.apolloColorBackgroundMenuItemDefault })));
//# sourceMappingURL=TagEditor.style.js.map